import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export enum KpxSubmissionStatusType {
  InProgress = 'InProgress',
  Submitted = 'Submitted',
  Failed = 'Failed',
  Unknown = 'Unknown',
}

interface KpxSubmissionStatusProps {
  className?: string;
  status: KpxSubmissionStatusType;
}

const KpxSubmissionStatus: React.FC<KpxSubmissionStatusProps> = ({
  className,
  status,
}) => {
  const { t } = useTranslation();
  const getColor = useMemo(() => {
    switch (status) {
      case KpxSubmissionStatusType.InProgress:
        return 'bg-orange-main';
      case KpxSubmissionStatusType.Submitted:
        return 'bg-teal-main';
      case KpxSubmissionStatusType.Failed:
        return 'bg-red-dark';
      case KpxSubmissionStatusType.Unknown:
        return 'bg-yellow-dark';
    }
  }, [status]);
  return (
    <div
      className={`${getColor} pop-10-medium inline-block rounded-[4px] px-[7px] py-[4px] text-white ${className}`}
    >
      {t('forecast.kpxStatus', { context: status })}
    </div>
  );
};

export default KpxSubmissionStatus;
